import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import {
	StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

/*******************************************************************************
 * Address Step Routing
 */
export const addressGraph: Beacon<StepMap> = {
	[steps.Address]: [steps.SystemAge],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	return steps.SystemAge as StepMap;
};
